import { logger } from './logger';

interface EnvConfig {
  VITE_SUPABASE_URL: string;
  VITE_SUPABASE_ANON_KEY: string;
  VITE_OPENAI_MODEL: string;
  VITE_STRIPE_PUBLIC_KEY: string;
  VITE_ENABLE_AI_FEATURES: boolean;
  VITE_ENABLE_ANALYTICS: boolean;
  VITE_ENABLE_PAYMENTS: boolean;
}

declare global {
  interface Window {
    env?: Record<string, string>;
  }
}

function getEnvVar(key: string): string {
  const viteKey = `VITE_${key}`;
  if ((import.meta.env as any)[viteKey]) {
    return (import.meta.env as any)[viteKey];
  }

  if (typeof window !== 'undefined' && window.env && window.env[viteKey]) {
    return window.env[viteKey];
  }

  if ((import.meta.env as any)[key]) {
    return (import.meta.env as any)[key];
  }

  return '';
}

function getRequiredEnvVar(key: string): string {
  const value = getEnvVar(key);
  if (!value) {
    logger.warn(`Required environment variable ${key} not found`);
  }
  return value;
}

export const env: EnvConfig = {
  VITE_SUPABASE_URL: getRequiredEnvVar('SUPABASE_URL'),
  VITE_SUPABASE_ANON_KEY: getRequiredEnvVar('SUPABASE_ANON_KEY'),
  VITE_OPENAI_MODEL: getEnvVar('OPENAI_MODEL') || 'gpt-4o',
  VITE_STRIPE_PUBLIC_KEY: getEnvVar('STRIPE_PUBLIC_KEY'),
  VITE_ENABLE_AI_FEATURES: true,
  VITE_ENABLE_ANALYTICS: getEnvVar('ENABLE_ANALYTICS') === 'true',
  VITE_ENABLE_PAYMENTS: getEnvVar('ENABLE_PAYMENTS') === 'true'
};

export const isValidConfig = Boolean(
  env.VITE_SUPABASE_URL &&
  env.VITE_SUPABASE_ANON_KEY
);